import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export default function GlobalLoader() {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        width: '100%',
        bgcolor: 'background.default'
      }}
    >
      <CircularProgress size={50} thickness={4} />
      <Typography variant="h6" color="textSecondary" sx={{ mt: 3, fontWeight: 500 }}>
        Loading MEAL Application...
      </Typography>
    </Box>
  );
}
